export const getSelectedCollectionsByIds = (collectionsData, selectedCollectionsIds) => {
    if (!collectionsData) {
        return [];
    }
    return collectionsData?.filter((collection) => {
        return selectedCollectionsIds.includes(collection.id);
    });
};
